import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const DoorHeight = ({ value, onChange, label = 'Door Slub Height:' }) => {
    const [selectedDoorHeight, setSelectedDoorHeight] = useState(value || "6'8");

    const handleDoorHeightChange = (e) => {
        setSelectedDoorHeight(e.target.value);
        onChange(e.target.value);
    };

     // Trigger onChange when the component is initialized
     useEffect(() => {
        if (selectedDoorHeight){
            onChange(selectedDoorHeight);
        }
    }, [onChange, selectedDoorHeight]);

    return (
        <div className="a-container">
            <label htmlFor="DoorHeight">{label}</label>
            <select
                id="DoorHeight"
                value={selectedDoorHeight}
                onChange={handleDoorHeightChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="6'8">{selectedDoorHeight === "6'8" ? "6'8 ✔" : "6'8"}</option>
                <option value="7">{selectedDoorHeight === "7" ? '7 \' ✔' : '7 \''}</option>
                <option value="8">{selectedDoorHeight === "8" ? '8 \' ✔' : '8 \''}</option>
            </select>
        </div>
    );
};

export default DoorHeight;
